<template>
  <div class="stat-root">
    <div class="query-bar">
      <el-date-picker v-model="startDate" value-format="yyyy-MM-dd" type="date" size="medium" placeholder="起始日期"
        style="width: 160px" />
      <span class="split">至</span>
      <el-date-picker v-model="endDate" value-format="yyyy-MM-dd" type="date" size="medium" placeholder="截止日期"
        style="width: 160px" />
      <el-select v-model="providerId" clearable size="medium" placeholder="请选择服务商" style="width: 180px">
        <el-option v-for="item in providerOpts" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-radio-group v-if="view !== 'driver'" v-model="grain" size="medium" @change="query">
        <el-radio-button label="year">年</el-radio-button>
        <el-radio-button label="month">月</el-radio-button>
        <el-radio-button label="week">周</el-radio-button>
        <el-radio-button label="day">日</el-radio-button>
      </el-radio-group>
      <el-button size="medium" type="primary" @click="query">查询</el-button>
      <span class="tip">统计已办且未驳回的工单，金额单位：元</span>
    </div>

    <el-tabs v-model="view">
      <el-tab-pane label="次数趋势" name="count" lazy>
        <chart v-if="loaded" :key="'count-' + chartKey" :option="countOption" :height="360" />
        <el-table :data="periods" border size="small" max-height="420" style="margin-top: 12px" show-summary
          :summary-method="summarizeCount">
          <el-table-column prop="period" label="时间" width="120" />
          <el-table-column label="合计" width="90">
            <template slot-scope="scope">{{ rowCount(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-for="item in serviceTypes" :key="item.value" :label="item.label" min-width="90">
            <template slot-scope="scope">{{ countOf(scope.row, item.value) }}</template>
          </el-table-column>
        </el-table>
        <div class="sub-block">
          <div class="sub-title">小类次数</div>
          <el-radio-group v-model="projType" size="small">
            <el-radio-button v-for="item in projTypes" :key="item.value" :label="item.value">{{ item.label
              }}</el-radio-button>
          </el-radio-group>
          <chart v-if="loaded && projCountOption" :key="'proj-count-' + chartKey + '-' + projType"
            :option="projCountOption" :height="320" style="margin-top: 12px" />
          <div v-else class="empty-tip">该大类在当前区间没有小类次数</div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="费用趋势" name="amount" lazy>
        <chart v-if="loaded" :key="'amount-' + chartKey" :option="amountOption" :height="360" />
        <el-table :data="periods" border size="small" max-height="420" style="margin-top: 12px" show-summary
          :summary-method="summarizeAmount">
          <el-table-column prop="period" label="时间" width="120" />
          <el-table-column label="合计" width="110">
            <template slot-scope="scope">{{ money(rowAmount(scope.row)) }}</template>
          </el-table-column>
          <el-table-column v-for="item in serviceTypes" :key="item.value" :label="item.label" min-width="100">
            <template slot-scope="scope">{{ money(amountOf(scope.row, item.value)) }}</template>
          </el-table-column>
        </el-table>
        <div class="sub-block">
          <div class="sub-title">小类费用</div>
          <el-radio-group v-model="projType" size="small">
            <el-radio-button v-for="item in projTypes" :key="item.value" :label="item.value">{{ item.label
              }}</el-radio-button>
          </el-radio-group>
          <chart v-if="loaded && projAmountOption" :key="'proj-amount-' + chartKey + '-' + projType"
            :option="projAmountOption" :height="320" style="margin-top: 12px" />
          <div v-else class="empty-tip">该大类在当前区间没有小类费用</div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="费用占比" name="ratio" lazy>
        <div class="ratio-charts">
          <div>
            <div class="sub-title">区间大类占比</div>
            <chart v-if="loaded && typePieOption" :key="'type-pie-' + chartKey" :option="typePieOption" :height="320" />
            <div v-else class="empty-tip">当前区间没有费用</div>
          </div>
          <div>
            <div class="sub-title">{{ projTypeLabel }}小类占比</div>
            <el-radio-group v-model="projType" size="small">
              <el-radio-button v-for="item in projTypes" :key="item.value" :label="item.value">{{ item.label
                }}</el-radio-button>
            </el-radio-group>
            <chart v-if="loaded && projPieOption" :key="'proj-pie-' + chartKey + '-' + projType" :option="projPieOption"
              :height="300" style="margin-top: 8px" />
            <div v-else class="empty-tip">该大类没有小类费用</div>
          </div>
        </div>
        <div class="sub-title">按时间的大类占比</div>
        <chart v-if="loaded" :key="'ratio-' + chartKey" :option="ratioOption" :height="360" />
      </el-tab-pane>

      <el-tab-pane label="司机分析" name="driver" lazy>
        <div class="driver-charts">
          <div>
            <div class="sub-title">费用 Top 司机</div>
            <chart v-if="loaded && driverAmountOption" :key="'drv-amt-' + chartKey + '-' + driverKeyword"
              :option="driverAmountOption" :height="320" />
            <div v-else class="empty-tip">没有司机费用数据</div>
          </div>
          <div>
            <div class="sub-title">次数 Top 司机</div>
            <chart v-if="loaded && driverCountOption" :key="'drv-cnt-' + chartKey + '-' + driverKeyword"
              :option="driverCountOption" :height="320" />
            <div v-else class="empty-tip">没有司机次数数据</div>
          </div>
        </div>
        <div class="query-bar">
          <el-input v-model="driverKeyword" size="medium" clearable placeholder="司机编号或姓名" style="width: 220px" />
        </div>
        <el-table :data="filteredDrivers" border size="small" max-height="480" highlight-current-row show-summary
          :summary-method="summarizeDriver" :default-sort="{ prop: 'totalAmount', order: 'descending' }"
          @current-change="onDriverChange">
          <el-table-column prop="driverNo" label="司机编号" width="100" />
          <el-table-column prop="driverName" label="姓名" width="100" />
          <el-table-column prop="totalCount" label="合计次数" width="100" sortable />
          <el-table-column prop="totalAmount" label="合计费用" width="110" sortable>
            <template slot-scope="scope">{{ money(scope.row.totalAmount) }}</template>
          </el-table-column>
          <el-table-column prop="share" label="费用占比" width="100" sortable>
            <template slot-scope="scope">{{ percent(scope.row.share) }}</template>
          </el-table-column>
          <el-table-column v-for="item in serviceTypes" :key="item.value" :label="item.label">
            <el-table-column :prop="'count_' + item.value" label="次数" width="70" sortable />
            <el-table-column :prop="'amount_' + item.value" label="费用" width="90" sortable>
              <template slot-scope="scope">{{ money(scope.row['amount_' + item.value]) }}</template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <div v-if="currentDriver" class="sub-block">
          <div class="sub-title">{{ currentDriver.driverNo }} {{ currentDriver.driverName }} 的费用构成</div>
          <div class="ratio-charts">
            <chart v-if="driverPieOption" :key="'drv-pie-' + (currentDriver.driverId || currentDriver.driverNo)"
              :option="driverPieOption" :height="280" />
            <el-table :data="currentDriver.projects || []" border size="small" max-height="280" show-summary
              :summary-method="summarizeProjects">
              <el-table-column label="大类" width="120">
                <template slot-scope="scope">{{ typeLabel(scope.row.type) }}</template>
              </el-table-column>
              <el-table-column prop="name" label="小类" min-width="140" />
              <el-table-column prop="count" label="次数" width="80" />
              <el-table-column label="费用" width="100">
                <template slot-scope="scope">{{ money(scope.row.amount) }}</template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getPartnerProviderList, statServiceBill } from "@/api/partner_admin";
import { DateUtil } from "@/util";
import Chart from "@/components/Chart";

const SERVICE_TYPES = [
  { value: "wash", label: "洗车", color: "#409EFF" },
  { value: "inspection", label: "检查", color: "#67C23A" },
  { value: "maintenance", label: "保养", color: "#E6A23C" },
  { value: "repair", label: "维修", color: "#F56C6C" },
  { value: "consumables", label: "损耗件", color: "#909399" },
  { value: "vme", label: "车载维护", color: "#8E44AD" },
  { value: "assess", label: "定损", color: "#16A085" }
];

const PROJ_TYPES = [
  { value: "repair", label: "维修" },
  { value: "consumables", label: "损耗件" },
  { value: "vme", label: "车载维护" }
];

export default {
  name: "partnerBillStat",
  components: { Chart },
  data() {
    return {
      serviceTypes: SERVICE_TYPES,
      projTypes: PROJ_TYPES,
      startDate: null,
      endDate: null,
      providerId: null,
      grain: "month",
      view: "count",
      projType: "repair",
      providerOpts: [],
      periods: [],
      drivers: [],
      driverKeyword: "",
      currentDriver: null,
      loaded: false,
      chartKey: 0
    };
  },
  computed: {
    projTypeLabel() {
      const found = PROJ_TYPES.find((item) => item.value === this.projType);
      return found ? found.label : "";
    },
    filteredDrivers() {
      const keyword = (this.driverKeyword || "").trim();
      if (!keyword) {
        return this.drivers;
      }
      return this.drivers.filter((item) => {
        return (item.driverNo || "").indexOf(keyword) >= 0 || (item.driverName || "").indexOf(keyword) >= 0;
      });
    },
    countOption() {
      return this.buildTypeBarOption("count");
    },
    amountOption() {
      return this.buildTypeBarOption("amount");
    },
    projCountOption() {
      return this.buildProjBarOption("count");
    },
    projAmountOption() {
      return this.buildProjBarOption("amount");
    },
    typePieOption() {
      const data = SERVICE_TYPES.map((item) => ({
        name: item.label,
        value: this.sumTypeAmount(item.value),
        itemStyle: { color: item.color }
      })).filter((item) => item.value > 0);
      return this.buildPieOption(data);
    },
    projPieOption() {
      const summed = {};
      this.periods.forEach((period) => {
        (period.projects || []).forEach((proj) => {
          if (proj.type !== this.projType) {
            return;
          }
          if (!summed[proj.code]) {
            summed[proj.code] = { name: proj.name, value: 0 };
          }
          summed[proj.code].value += Number(proj.amount || 0);
        });
      });
      const data = Object.keys(summed).map((code) => ({
        name: summed[code].name,
        value: Number(summed[code].value.toFixed(2))
      })).filter((item) => item.value > 0);
      return this.buildPieOption(data);
    },
    ratioOption() {
      return {
        tooltip: { trigger: "axis", valueFormatter: (value) => value + "%" },
        legend: { type: "scroll", bottom: 0 },
        grid: { left: 50, right: 20, top: 30, bottom: 60 },
        xAxis: { type: "category", data: this.periods.map((item) => item.period) },
        yAxis: { type: "value", max: 100, axisLabel: { formatter: "{value}%" } },
        series: SERVICE_TYPES.map((item) => ({
          name: item.label,
          type: "bar",
          stack: "ratio",
          itemStyle: { color: item.color },
          data: this.periods.map((period) => {
            const total = this.rowAmount(period);
            if (!total) {
              return 0;
            }
            return Number(((this.amountOf(period, item.value) / total) * 100).toFixed(2));
          })
        }))
      };
    },
    driverAmountOption() {
      return this.buildDriverBarOption("totalAmount", "费用");
    },
    driverCountOption() {
      return this.buildDriverBarOption("totalCount", "次数");
    },
    driverPieOption() {
      if (!this.currentDriver) {
        return null;
      }
      const data = SERVICE_TYPES.map((item) => ({
        name: item.label,
        value: Number(this.currentDriver["amount_" + item.value] || 0),
        itemStyle: { color: item.color }
      })).filter((item) => item.value > 0);
      return this.buildPieOption(data);
    }
  },
  mounted() {
    this.endDate = DateUtil.getDayStr(15);
    this.startDate = DateUtil.format(new Date(), "yyyy-MM") + "-01";
    getPartnerProviderList().then((res) => {
      const data = res.data || {};
      this.providerOpts = data.providers || [];
    });
    this.query();
  },
  methods: {
    query() {
      if (!this.startDate || !this.endDate) {
        this.$message.warning("请选择统计日期");
        return;
      }
      statServiceBill({
        startDate: this.startDate,
        endDate: this.endDate,
        grain: this.grain,
        providerId: this.providerId
      }).then((res) => {
        const data = res.data || {};
        this.periods = data.periods || [];
        const drivers = data.drivers || [];
        const totalAmount = drivers.reduce((sum, item) => sum + Number(item.totalAmount || 0), 0);
        drivers.forEach((driver) => {
          SERVICE_TYPES.forEach((type) => {
            driver["count_" + type.value] = driver.counts ? Number(driver.counts[type.value] || 0) : 0;
            driver["amount_" + type.value] = driver.amounts ? Number(driver.amounts[type.value] || 0) : 0;
          });
          driver.share = totalAmount ? Number(driver.totalAmount || 0) / totalAmount : 0;
        });
        this.drivers = drivers;
        this.currentDriver = drivers.length ? drivers[0] : null;
        this.loaded = true;
        this.chartKey += 1;
      });
    },
    countOf(row, type) {
      return row.counts ? Number(row.counts[type] || 0) : 0;
    },
    amountOf(row, type) {
      return row.amounts ? Number(row.amounts[type] || 0) : 0;
    },
    rowCount(row) {
      return SERVICE_TYPES.reduce((sum, item) => sum + this.countOf(row, item.value), 0);
    },
    rowAmount(row) {
      return SERVICE_TYPES.reduce((sum, item) => sum + this.amountOf(row, item.value), 0);
    },
    summarizeCount({ columns, data }) {
      return columns.map((column, index) => {
        if (index === 0) {
          return "合计";
        }
        if (column.label === "合计") {
          return data.reduce((sum, row) => sum + this.rowCount(row), 0);
        }
        const type = SERVICE_TYPES.find((item) => item.label === column.label);
        if (!type) {
          return "";
        }
        return data.reduce((sum, row) => sum + this.countOf(row, type.value), 0);
      });
    },
    summarizeAmount({ columns, data }) {
      return columns.map((column, index) => {
        if (index === 0) {
          return "合计";
        }
        if (column.label === "合计") {
          return this.money(data.reduce((sum, row) => sum + this.rowAmount(row), 0));
        }
        const type = SERVICE_TYPES.find((item) => item.label === column.label);
        if (!type) {
          return "";
        }
        return this.money(data.reduce((sum, row) => sum + this.amountOf(row, type.value), 0));
      });
    },
    summarizeDriver({ columns, data }) {
      return columns.map((column, index) => {
        if (index === 0) {
          return "合计";
        }
        const prop = column.property;
        if (!prop || prop === "driverName" || prop === "share") {
          return "";
        }
        const total = data.reduce((sum, row) => sum + Number(row[prop] || 0), 0);
        if (prop.indexOf("amount") >= 0 || prop === "totalAmount") {
          return this.money(total);
        }
        return total;
      });
    },
    summarizeProjects({ columns, data }) {
      return columns.map((column, index) => {
        if (index === 0) {
          return "合计";
        }
        if (column.property === "count") {
          return data.reduce((sum, row) => sum + Number(row.count || 0), 0);
        }
        if (column.label === "费用") {
          return this.money(data.reduce((sum, row) => sum + Number(row.amount || 0), 0));
        }
        return "";
      });
    },
    sumTypeAmount(type) {
      return Number(this.periods.reduce((sum, period) => sum + this.amountOf(period, type), 0).toFixed(2));
    },
    money(value) {
      return Number(value || 0).toFixed(2);
    },
    percent(value) {
      return (Number(value || 0) * 100).toFixed(2) + "%";
    },
    typeLabel(type) {
      const found = SERVICE_TYPES.find((item) => item.value === type);
      return found ? found.label : type;
    },
    onDriverChange(row) {
      this.currentDriver = row;
    },
    buildTypeBarOption(metric) {
      return {
        tooltip: { trigger: "axis" },
        legend: { type: "scroll", bottom: 0 },
        grid: { left: 50, right: 20, top: 30, bottom: 60 },
        xAxis: { type: "category", data: this.periods.map((item) => item.period) },
        yAxis: { type: "value" },
        series: SERVICE_TYPES.map((item) => ({
          name: item.label,
          type: "bar",
          itemStyle: { color: item.color },
          data: this.periods.map((period) => (metric === "count" ? this.countOf(period, item.value) : this.amountOf(period, item.value)))
        }))
      };
    },
    buildProjBarOption(metric) {
      const nameMap = {};
      this.periods.forEach((period) => {
        (period.projects || []).forEach((proj) => {
          if (proj.type === this.projType) {
            nameMap[proj.code] = proj.name;
          }
        });
      });
      const codes = Object.keys(nameMap);
      if (!codes.length) {
        return null;
      }
      return {
        tooltip: { trigger: "axis" },
        legend: { type: "scroll", bottom: 0 },
        grid: { left: 50, right: 20, top: 30, bottom: 70 },
        xAxis: { type: "category", data: this.periods.map((item) => item.period) },
        yAxis: { type: "value" },
        series: codes.map((code) => ({
          name: nameMap[code],
          type: "bar",
          data: this.periods.map((period) => {
            const found = (period.projects || []).find((proj) => proj.type === this.projType && proj.code === code);
            return found ? Number(found[metric] || 0) : 0;
          })
        }))
      };
    },
    buildPieOption(data) {
      if (!data.length) {
        return null;
      }
      return {
        tooltip: { trigger: "item", formatter: "{b}: {c} ({d}%)" },
        legend: { type: "scroll", bottom: 0 },
        series: [
          {
            type: "pie",
            radius: ["38%", "68%"],
            center: ["50%", "45%"],
            data
          }
        ]
      };
    },
    buildDriverBarOption(field, name) {
      const top = this.filteredDrivers.slice().sort((a, b) => Number(b[field] || 0) - Number(a[field] || 0)).slice(0, 10);
      if (!top.length) {
        return null;
      }
      const rows = top.reverse();
      return {
        tooltip: { trigger: "axis" },
        grid: { left: 120, right: 20, top: 10, bottom: 30 },
        xAxis: { type: "value" },
        yAxis: {
          type: "category",
          data: rows.map((item) => (item.driverNo || "") + " " + (item.driverName || ""))
        },
        series: [
          {
            name,
            type: "bar",
            data: rows.map((item) => Number(item[field] || 0)),
            itemStyle: { color: field === "totalAmount" ? "#E6A23C" : "#409EFF" }
          }
        ]
      };
    }
  }
};
</script>

<style scoped>
.stat-root {
  padding-bottom: 20px;
}

.query-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding-bottom: 12px;
}

.split {
  color: #606266;
}

.tip {
  color: #909399;
  font-size: 12px;
}

.sub-block {
  margin-top: 16px;
}

.sub-title {
  margin: 8px 0;
  font-weight: 600;
  color: #303133;
}

.empty-tip {
  color: #909399;
  padding: 24px 0;
}

.ratio-charts,
.driver-charts {
  display: flex;
  gap: 16px;
}

.ratio-charts>div,
.driver-charts>div {
  flex: 1;
  min-width: 0;
}
</style>
